import React, { ChangeEvent, useState } from 'react';
import '../../../css/formulaire.css';
import { ToastContainer } from 'react-toastify';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import DateComponent from '../../commonComponents/DateComponent';
import { DateType } from '../../../static/types/commonTypes/dateType';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import Manager from '../../commonComponents/Manager';
import ReducedManager from '../../commonComponents/ReducedManager';
import { initialManagerState } from '../../../static/types/objectInitialState';
import { initialReducedManagerState } from '../../../static/initialState/commonInitialState/initialReducedManagerState';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { ManagerType } from '../../../static/types/commonTypes/managerType';
import { ReducedManagerType } from '../../../static/types/commonTypes/reducedManagerType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const RemplacementCAC: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,

}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        dateWhithEffectiveDate, setDateWhithEffectiveDate,
        dateWhithEffectiveDateValidity, setDateWhithEffectiveDateValidity,
        dateWhithEffectiveDateChecked, setDateWhithEffectiveDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        auditorsChange, setAuditorsChange,

        newStatutoryAuditor, setNewStatutoryAuditor,
        newStatutoryAuditorValidity, setNewStatutoryAuditorValidity,
        newStatutoryAuditorChecked, setNewStatutoryAuditorChecked,

        formerStatutoryAuditor, setFormerStatutoryAuditor,
        formerStatutoryAuditorValidity, setFormerStatutoryAuditorValidity,
        formerStatutoryAuditorChecked, setFormerStatutoryAuditorChecked,

        // new reduced statutory auditor for Departure with replacement of the statutory auditor and alternate(ManagerType)
        newAlternateAuditor, setNewAlternateAuditor,
        newAlternateAuditorValidity, setNewAlternateAuditorValidity,
        newAlternateAuditorChecked, setNewAlternateAuditorChecked,
        typeNewAlternateAuditorData, setTypeNewAlternateAuditorData,

        // former reduced statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
        formerAlternateAuditor, setFormerAlternateAuditor,
        formerAlternateAuditorValidity, setFormerAlternateAuditorValidity,
        formerAlternateAuditorChecked, setFormerAlternateAuditorChecked,
        typeFormerAlternateAuditorData, setTypeFormerAlternateAuditorData,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false);
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateDate = (dater: Partial<DateType>) => setDateWhithEffectiveDate({ ...dateWhithEffectiveDate, ...dater });

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const managerText = (manager: ManagerType): string => {
                if (manager.person === "Personne morale") {
                    return manager.entityDetails.rcs ? ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : ``
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
                else return ""
            }

            const reducedManagerText = (manager: ReducedManagerType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}`
                }
                else return ''
            }

            const effectiveDateText = dateWhithEffectiveDate.effectiveDate ? `à compter du ${dateWhithEffectiveDate.effectiveDate}` : ``

            const auditorText = (): string => {
                let res = ``

                if (auditorsChange === 1) {
                    res = typeNewAlternateAuditorData === 1
                        ? `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText} Commissaires Aux Comptes Titulaire et Suppléant respectivement : ${managerText(newStatutoryAuditor)} et ${managerText(newAlternateAuditor)}.`
                        : `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText} Commissaire Aux Comptes Titulaire, ${managerText(newStatutoryAuditor)}.`
                }
                else if (auditorsChange === 2) {
                    res = typeFormerAlternateAuditorData === 1
                        ? `L'AG du ${dateWhithEffectiveDate.date} a pris acte de la cessation des fonctions des Commissaires Aux Comptes Titulaire et Suppléant respectivement, ${reducedManagerText(formerStatutoryAuditor)} et ${reducedManagerText(formerAlternateAuditor)}.`
                        : `L'AG du ${dateWhithEffectiveDate.date} a pris acte de la cessation des fonctions du Commissaire Aux Comptes Titulaire, ${reducedManagerText(formerStatutoryAuditor)}.`
                }
                else if (auditorsChange === 3) {
                    res = `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText} Commissaire Aux Comptes Titulaire : ${managerText(newStatutoryAuditor)}, en remplacement de ${reducedManagerText(formerStatutoryAuditor)}.`
                }
                else if (auditorsChange === 4) {
                    res = `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText} Commissaire Aux Comptes Suppléant : ${managerText(newAlternateAuditor)}, en remplacement de ${reducedManagerText(formerAlternateAuditor)}.`
                }
                else if (auditorsChange === 5) {
                    if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 0)
                        res = `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText} Commissaire Aux Comptes Titulaire : ${managerText(newAlternateAuditor)}, en remplacement de ${reducedManagerText(formerAlternateAuditor)}.`

                    else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1)
                        res = `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText}
- Commissaire Aux Comptes Titulaire : ${managerText(newStatutoryAuditor)}, en remplacement de ${reducedManagerText(formerStatutoryAuditor)}
- Commissaire Aux Comptes Suppléant : ${managerText(newAlternateAuditor)}, en remplacement de ${reducedManagerText(formerAlternateAuditor)}`

                    else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0)
                        res = `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText}
- Commissaire Aux Comptes Titulaire : ${managerText(newStatutoryAuditor)}, en remplacement de ${reducedManagerText(formerStatutoryAuditor)}.
- Commissaire Aux Comptes Suppléant : ${managerText(newAlternateAuditor)}.`

                    else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 0)
                        res = `L'AG du ${dateWhithEffectiveDate.date} a nommé ${effectiveDateText}
- Commissaire Aux Comptes Titulaire : ${managerText(newStatutoryAuditor)}, en remplacement de ${reducedManagerText(formerStatutoryAuditor)}.
Et a pris acte de la cessation des fonctions des Commissaires Aux Comptes Suppléant, ${reducedManagerText(formerAlternateAuditor)}.`
                }
                return res
            }

            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
${auditorText()}
Modification du RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
        else setSubmissive(false)
    };

    const auditorValidity = (): boolean => {

        let res = false

        if (auditorsChange === 1) {
            if (typeNewAlternateAuditorData === 1) {
                if (newStatutoryAuditorValidity && newAlternateAuditorValidity) res = true
            }
            else if (newStatutoryAuditorValidity) res = true
        }
        else if (auditorsChange === 2) {
            if (typeFormerAlternateAuditorData === 1) {
                if (formerStatutoryAuditorValidity && formerAlternateAuditorValidity) res = true
            }
            else if (formerStatutoryAuditorValidity) res = true
        }
        else if (auditorsChange === 3) {
            if (newStatutoryAuditorValidity && formerStatutoryAuditorValidity) res = true
        }
        else if (auditorsChange === 4) {
            if (newAlternateAuditorValidity && formerAlternateAuditorValidity) res = true
        }
        else if (auditorsChange === 5) {
            if (newStatutoryAuditorValidity && formerStatutoryAuditorValidity) {
                if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1) {
                    if (newAlternateAuditorValidity && formerAlternateAuditorValidity) res = true
                }
                else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0) {
                    if (newAlternateAuditorValidity) res = true
                }
                else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1) {
                    if (formerAlternateAuditorValidity) res = true
                }
                else res = true
            }
        }

        return res
    }

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName');
        } else if (!dateWhithEffectiveDateValidity) {
            setActiveTab('appointmentStatutoryAuditor');
        } else if (!legalEntityValidity) {
            setActiveTab('theSociety');
        }
        else if (auditorsChange === 1) {
            if (typeNewAlternateAuditorData === 1) {
                if (!(newStatutoryAuditorValidity && newAlternateAuditorValidity)) setActiveTab('commissaireAuCompte')
            }
            else if (!newStatutoryAuditorValidity) setActiveTab('commissaireAuCompte')
        }
        else if (auditorsChange === 2) {
            if (typeFormerAlternateAuditorData === 1) {
                if (!(formerStatutoryAuditorValidity && formerAlternateAuditorValidity)) setActiveTab('commissaireAuCompte')
            }
            else if (!formerStatutoryAuditorValidity) setActiveTab('commissaireAuCompte')
        }
        else if (auditorsChange === 3) {
            if (!(newStatutoryAuditorValidity && formerStatutoryAuditorValidity)) setActiveTab('commissaireAuCompte')
        }
        else if (auditorsChange === 4) {
            if (!(newAlternateAuditorValidity && formerAlternateAuditorValidity)) setActiveTab('commissaireAuCompte')
        }
        else if (auditorsChange === 5) {
            if (!(newStatutoryAuditorValidity && formerStatutoryAuditorValidity)) setActiveTab('commissaireAuCompte')

            if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1) {
                if (!(newAlternateAuditorValidity && formerAlternateAuditorValidity)) setActiveTab('commissaireAuCompte')
            }
            else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0) {
                if (!newAlternateAuditorValidity) setActiveTab('commissaireAuCompte')
            }
            else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1) {
                if (!formerAlternateAuditorValidity) setActiveTab('commissaireAuCompte')
            }
        }

        let tempAuditorValidation = auditorValidity()

        return companyNameValidity && dateWhithEffectiveDateValidity && legalEntityValidity && tempAuditorValidation;
    };


    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true);
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "appointmentStatutoryAuditor") {
            setDateWhithEffectiveDateChecked(true);
            if (dateWhithEffectiveDateValidity) {
                switchTab(getNextTab("appointmentStatutoryAuditor"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true);
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "commissaireAuCompte") {
            if (auditorsChange === 1) {
                setNewStatutoryAuditorChecked(true)
                if (typeNewAlternateAuditorData === 1) {
                    setNewAlternateAuditorChecked(true)
                    if (newStatutoryAuditorValidity && newAlternateAuditorValidity) setSubmissive(true)
                }
                else if (newStatutoryAuditorValidity) setSubmissive(true)
            }
            else if (auditorsChange === 2) {
                setFormerStatutoryAuditorChecked(true)
                if (typeFormerAlternateAuditorData === 1) {
                    setFormerAlternateAuditorChecked(true)
                    if (formerStatutoryAuditorValidity && formerAlternateAuditorValidity) setSubmissive(true)
                }
                else if (formerStatutoryAuditorValidity) setSubmissive(true)
            }
            else if (auditorsChange === 3) {
                setNewStatutoryAuditorChecked(true)
                setFormerStatutoryAuditorChecked(true)
                if (newStatutoryAuditorValidity && formerStatutoryAuditorValidity) setSubmissive(true)
            }
            else if (auditorsChange === 4) {
                setNewAlternateAuditorChecked(true)
                setFormerAlternateAuditorChecked(true)
                if (newAlternateAuditorValidity && formerAlternateAuditorValidity) setSubmissive(true)
            }
            else if (auditorsChange === 5) {
                setNewStatutoryAuditorChecked(true)
                setFormerStatutoryAuditorChecked(true)
                if (newStatutoryAuditorValidity && formerStatutoryAuditorValidity) {
                    if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1) {
                        if (newAlternateAuditorValidity && formerAlternateAuditorValidity) setSubmissive(true)
                    }
                    else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0) {
                        if (newAlternateAuditorValidity) setSubmissive(true)
                    }
                    else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1) {
                        if (formerAlternateAuditorValidity) setSubmissive(true)
                    }
                    else setSubmissive(true)
                }
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "appointmentStatutoryAuditor";
        else if (currentTab === "appointmentStatutoryAuditor") return "theSociety";
        else if (currentTab === "theSociety") return "commissaireAuCompte";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "commissaireAuCompte") return "theSociety";
        else if (currentTab === "theSociety") return "appointmentStatutoryAuditor";
        else if (currentTab === "appointmentStatutoryAuditor") return "companyName";
        else return currentTab;
    };

    const goToSupportPresse = () => updateActiveIndex(2)

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleToggleAuditorsChange = (event: ChangeEvent<HTMLSelectElement>) => {

        setAuditorsChange(Number(event.target.value))
        setSubmissive(false)

        setNewStatutoryAuditor(initialManagerState)
        setNewStatutoryAuditorValidity(false)
        setNewStatutoryAuditorChecked(false)

        setNewAlternateAuditor(initialManagerState)
        setNewAlternateAuditorValidity(false)
        setNewAlternateAuditorChecked(false)
        setTypeNewAlternateAuditorData(0)

        setFormerStatutoryAuditor(initialReducedManagerState)
        setFormerStatutoryAuditorValidity(false)
        setFormerStatutoryAuditorChecked(false)

        setFormerAlternateAuditor(initialReducedManagerState)
        setFormerAlternateAuditorValidity(false)
        setFormerAlternateAuditorChecked(false)
        setTypeFormerAlternateAuditorData(0)
    }

    const tabs = [
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'appointmentStatutoryAuditor', label: 'Nomination du commissaire au compte'},
        {key: 'theSociety', label: 'La société'},
        {key: 'commissaireAuCompte', label: 'Commissaires aux comptes'}
    ]
    

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>

                    </div>
                }

                {
                    activeTab === 'appointmentStatutoryAuditor' &&
                    <DateComponent
                        checked={dateWhithEffectiveDateChecked}
                        changeDate={updateDate}
                        date={dateWhithEffectiveDate}
                        draftFieldName = 'dateWhithEffectiveDate'
                        dateLabel="Date de l'AG"
                        onValidationChange={(isValid: boolean) => setDateWhithEffectiveDateValidity(isValid)}
                        required={true}
                        id='dateWhithEffectiveDateCAC'
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                        checked={legalEntityChecked}
                        legalEntity={legalEntity}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                        societyType={societyTypeOptions}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'commissaireAuCompte' &&
                    <div >
                        <div className='col-sm-10 d-flex align-items-center mt-1'>
                            <label htmlFor="modification" className="col-sm-2 col-form-label mb-0">
                                Modification
                            </label>
                            <select
                                className='form-select w-75'
                                id="modificationCAC"
                                onChange={handleToggleAuditorsChange}
                                value={auditorsChange}>
                                <option value={0}>Aucune modification</option>
                                <option value={1}>Nomination</option>
                                <option value={2}>Départ sans remplacement</option>
                                <option value={3}>Départ avec remplacement du titulaire</option>
                                <option value={4}>Départ avec remplacement du suppléant</option>
                                <option value={5}>Départ avec remplacement du titulaire et suppléant</option>
                            </select>
                        </div>

                        {
                            auditorsChange === 1 &&
                            <div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Commissaire aux comptes titulaire
                                    </h6>
                                    <Manager
                                        manager={newStatutoryAuditor}
                                        setManager={setNewStatutoryAuditor}
                                        checked={newStatutoryAuditorChecked}
                                        setChecked={setNewStatutoryAuditorChecked}
                                        societyType={societyTypeOptions}
                                        updateManagerValidity={(isValid: boolean) => setNewStatutoryAuditorValidity(isValid)}
                                        draftFieldName = 'newStatutoryAuditor'
                                    />
                                </div>
                                <div className='row align-items-center mt-3'>
                                    <h6 className='text-bold'>
                                        Commissaire aux comptes suppléant
                                    </h6>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select w-25"
                                            id="person"
                                            onChange={(event) => {
                                                setNewAlternateAuditor(initialManagerState)
                                                setTypeNewAlternateAuditorData(Number(event.target.value))
                                            }}
                                            value={typeNewAlternateAuditorData}
                                        >
                                            <option value={1}> Oui </option>
                                            <option value={0}> Non </option>
                                        </select>
                                    </div>
                                    {
                                        typeNewAlternateAuditorData === 1 &&
                                        <div>
                                            <div className='mt-3'>
                                                <Manager
                                                    manager={newAlternateAuditor}
                                                    checked={newAlternateAuditorChecked}
                                                    setChecked={setNewAlternateAuditorChecked}
                                                    setManager={setNewAlternateAuditor}
                                                    societyType={societyTypeOptions}
                                                    updateManagerValidity={(isValid: boolean) => setNewAlternateAuditorValidity(isValid)}
                                                    draftFieldName = 'newAlternateAuditor'
                                                />
                                            </div>
                                        </div>

                                    }

                                </div>
                            </div>
                        }

                        {
                            auditorsChange === 2 &&
                            <div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Commissaire aux comptes titulaire
                                    </h6>
                                    <ReducedManager
                                        checked={formerStatutoryAuditorChecked}
                                        manager={formerStatutoryAuditor}
                                        draftFieldName = 'formerStatutoryAuditor'
                                        setChecked={setFormerStatutoryAuditorChecked}
                                        setManager={setFormerStatutoryAuditor}
                                        updateManagerValidity={(isValid) => setFormerStatutoryAuditorValidity(isValid)}
                                    />
                                </div>
                                <div className='row align-items-center mt-3'>
                                    <h6 className='text-bold'>
                                        Commissaire aux comptes suppléant
                                    </h6>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select w-25"
                                            id="person"
                                            onChange={(event) => {
                                                setFormerAlternateAuditor(initialReducedManagerState)
                                                setTypeFormerAlternateAuditorData(Number(event.target.value))
                                            }}
                                            value={typeFormerAlternateAuditorData}
                                        >
                                            <option value={1}> Oui </option>
                                            <option value={0}> Non </option>
                                        </select>
                                    </div>
                                    {
                                        typeFormerAlternateAuditorData === 1 &&
                                        <div>
                                            <div className='mt-3'>
                                                <ReducedManager
                                                    manager={formerAlternateAuditor}
                                                    draftFieldName = 'formerAlternateAuditor'
                                                    setManager={setFormerAlternateAuditor}
                                                    setChecked={setFormerAlternateAuditorChecked}
                                                    checked={formerAlternateAuditorChecked}
                                                    updateManagerValidity={(isValid) => setFormerAlternateAuditorValidity(isValid)}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                        {
                            auditorsChange === 3 &&
                            <div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Nouveau commissaire aux comptes titulaire
                                    </h6>
                                    <Manager
                                        manager={newStatutoryAuditor}
                                        setManager={setNewStatutoryAuditor}
                                        checked={newStatutoryAuditorChecked}
                                        setChecked={setNewStatutoryAuditorChecked}
                                        societyType={societyTypeOptions}
                                        updateManagerValidity={(isValid: boolean) => setNewStatutoryAuditorValidity(isValid)}
                                        draftFieldName = 'newStatutoryAuditor'
                                    />
                                </div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Ancien commissaire aux comptes titulaire
                                    </h6>
                                    <ReducedManager
                                        checked={formerStatutoryAuditorChecked}
                                        manager={formerStatutoryAuditor}
                                        draftFieldName = 'formerStatutoryAuditor'
                                        setChecked={setFormerStatutoryAuditorChecked}
                                        setManager={setFormerStatutoryAuditor}
                                        updateManagerValidity={(isValid) => setFormerStatutoryAuditorValidity(isValid)}
                                    />
                                </div>

                            </div>
                        }

                        {
                            auditorsChange === 4 &&
                            <div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Nouveau commissaire aux comptes suppléant
                                    </h6>
                                    <Manager
                                        manager={newAlternateAuditor}
                                        checked={newAlternateAuditorChecked}
                                        setChecked={setNewAlternateAuditorChecked}
                                        setManager={setNewAlternateAuditor}
                                        societyType={societyTypeOptions}
                                        updateManagerValidity={(isValid: boolean) => setNewAlternateAuditorValidity(isValid)}
                                        draftFieldName = 'newAlternateAuditor'
                                    />
                                </div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Ancien commissaire aux comptes suppléant
                                    </h6>
                                    <ReducedManager
                                        manager={formerAlternateAuditor}
                                        draftFieldName = 'formerAlternateAuditor'
                                        setManager={setFormerAlternateAuditor}
                                        setChecked={setFormerAlternateAuditorChecked}
                                        checked={formerAlternateAuditorChecked}
                                        updateManagerValidity={(isValid) => setFormerAlternateAuditorValidity(isValid)}
                                    />
                                </div>

                            </div>
                        }

                        {
                            auditorsChange === 5 &&
                            <div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Nouveau commissaire aux comptes titulaire
                                    </h6>
                                    <Manager
                                        manager={newStatutoryAuditor}
                                        setManager={setNewStatutoryAuditor}
                                        checked={newStatutoryAuditorChecked}
                                        setChecked={setNewStatutoryAuditorChecked}
                                        societyType={societyTypeOptions}
                                        updateManagerValidity={(isValid: boolean) => setNewStatutoryAuditorValidity(isValid)}
                                        draftFieldName = 'newStatutoryAuditor'
                                    />
                                </div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Ancien commissaire aux comptes titulaire
                                    </h6>
                                    <ReducedManager
                                        checked={formerStatutoryAuditorChecked}
                                        manager={formerStatutoryAuditor}
                                        draftFieldName = 'formerStatutoryAuditor'
                                        setChecked={setFormerStatutoryAuditorChecked}
                                        setManager={setFormerStatutoryAuditor}
                                        updateManagerValidity={(isValid) => setFormerStatutoryAuditorValidity(isValid)}
                                    />
                                </div>
                                <div className="mt-3 row">
                                    <h6 className='text-bold'>
                                        Nouveau commissaire aux comptes suppléant
                                    </h6>
                                    <label htmlFor="personne" className="col-sm-2 col-form-label">
                                        Saisir données
                                    </label>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select w-25"
                                            id="person"
                                            onChange={(e) => {
                                                setNewAlternateAuditor(initialManagerState)
                                                setTypeNewAlternateAuditorData(Number(e.target.value))
                                            }}
                                            value={typeNewAlternateAuditorData}
                                        >
                                            <option value={1}> Oui </option>
                                            <option value={0}> Non </option>
                                        </select>
                                    </div>
                                    {
                                        typeNewAlternateAuditorData === 1 &&
                                        <div className='mt-3'>
                                            <Manager
                                                manager={newAlternateAuditor}
                                                checked={newAlternateAuditorChecked}
                                                setChecked={setNewAlternateAuditorChecked}
                                                setManager={setNewAlternateAuditor}
                                                societyType={societyTypeOptions}
                                                updateManagerValidity={(isValid: boolean) => setNewAlternateAuditorValidity(isValid)}
                                                draftFieldName = 'newAlternateAuditor'
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="mt-3 row">
                                    <h6 className='text-bold'>
                                        Ancien commissaire aux comptes suppléant
                                    </h6>
                                    <label htmlFor="personne" className="col-sm-2 col-form-label">
                                        Saisir données
                                    </label>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select w-25"
                                            id="person"
                                            onChange={(event) => {
                                                setFormerAlternateAuditor(initialReducedManagerState)
                                                setTypeFormerAlternateAuditorData(Number(event.target.value))
                                            }}
                                            value={typeFormerAlternateAuditorData}
                                        >
                                            <option value={1}> Oui </option>
                                            <option value={0}> Non </option>
                                        </select>
                                    </div>
                                    {
                                        typeFormerAlternateAuditorData === 1 &&
                                        <div className='mt-3'>
                                            <ReducedManager
                                                manager={formerAlternateAuditor}
                                                draftFieldName = 'formerAlternateAuditor'
                                                setManager={setFormerAlternateAuditor}
                                                setChecked={setFormerAlternateAuditorChecked}
                                                checked={formerAlternateAuditorChecked}
                                                updateManagerValidity={(isValid) => setFormerAlternateAuditorValidity(isValid)}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                    </div>
                }

                {
                    submissive &&
                    activeTab === 'commissaireAuCompte' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'commissaireAuCompte' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'commissaireAuCompte' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'commissaireAuCompte' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>

    );
};
export default RemplacementCAC;